
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20"}}),_c('text',{attrs:{"x":"10.721","y":"15.999","transform":"scale(.947 1.05598)","font-size":"6.708","stroke-width":".559"}},[_c('tspan',{attrs:{"x":"10.721","y":"15.999"}},[_v('У')])])])
          )
        }
      }
    